import * as React from "react";
import { useState, useEffect } from "react";
import { useStaticQuery, graphql } from "gatsby";
import GoogleApiWrapper from "./gmaps";
import { fontColorDark } from "./shared.module.scss";
import { getYardiPropId } from "../utils/propertyMapUtil";
import { trimKeys } from "../utils/helperFunctions";
import SearchNotMap from "./searchNotMap";

const Search = ({ city, state, percentAvail }) => {
  state = state ? state.charAt(0).toUpperCase() + state.slice(1) : "Michigan";
  city = city ? city : "ann-arbor";
  //city = city != 'winter-park' ? city : 'orlando';
  //const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    if (typeof window !== "undefined") {
      const handleResize = () => {
        setIsMobile(window.innerWidth < 768);
      };

      window.addEventListener("resize", handleResize);

      handleResize();

      return () => window.removeEventListener("resize", handleResize);
    }
  }, []);

  useEffect(() => {
    let c = {};
    let zoom = 10;
    switch (city) {
      case "ypsilanti":
        c = { lat: 42.254635, lon: -83.661045 };
        zoom = isMobile ? 10 : 12;
        break;
      case "ann-arbor":
        c = { lat: 42.268299, lon: -83.722214 };
        zoom = isMobile ? 10 : 13;
        break;
      case "winter-park":
        c = { lat: 28.598797, lon: -81.358315 };
        zoom = isMobile ? 10 : 13;
        break;
      case "orlando":
        c = { lat: 28.538336, lon: -81.379234 };
        zoom = isMobile ? 10 : 11;
        break;

      case "all":
        c = { lat: 36.586, lon: -84.418 };
        zoom = 6;
        break;
    }
    setCords(c);
    setZoom(zoom);
    setLoadingCords(false); // Update loading state when cords are set
  }, [city]);

  //static query here isn't actually taking in the dynamic filter
  //we are not actually able to filter by city and state here
  const data = useStaticQuery(graphql`
    query ($state: String, $city: String) {
      allContentfulCommunity(
        filter: { area: { eq: $state }, citySlug: { eq: $city } }
      ) {
        edges {
          node {
            id
            communityName
            slug
            address
            email
            phone
            area
            citySlug
            shortHours
            rmpropid
            exactLocation {
              lat
              lon
            }
            contactUsBanner {
              gatsbyImageData
            }
            hero {
              gatsbyImageData
            }
            maxBeds
            minBeds
            maxBaths
            maxBathsDec
            priceMin
            priceMax
            specials
            utilitiesIncluded
          }
        }
      }
    }
  `);

  const [viewing, setViewing] = useState([]);
  const [cords, setCords] = useState({});
  const [page, setPage] = useState([0, 1, 2]);
  const [zoom, setZoom] = useState(10);
  const [hoveringOver, setHoveringOver] = useState("");
  //const [minPrices, setMinPrices] = useState({});
  const [deals, setDeals] = useState({});
  const [communityDeals, setCommunityDeals] = useState([]); //a simple list of communities which have an active deal
  const [priceRange, setPriceRange] = useState([]);
  const [proformaRange, setProformaRange] = useState([]);
  const [loadingCords, setLoadingCords] = useState(true); // New loading state
  const [avShortcut, setAvShortcut] = useState([]);
  const [filter, setFilter] = useState({ bed: "", bath: "", rent: "", av: "" });
  const [originalViewing, setOriginalViewing] = useState([]);

  useEffect(() => {
    //start here. Component Load.
    const initialize = async () => {
      //await configMinPrices(); Not needed when switching to Yardi
      await getDeals();
      await getPriceRange(); // Get only available market rent
      await getProformaRange(); // Get market rent for everything
      await getAvShortcut(); // Get available data for all coms (simple form)
      restoreViewing();
    };
    initialize();
  }, []);

  const getDeals = async () => {
    await fetch("https://redisut.mcklab.com/index.php?action=getDeals")
      .then((response) => response.json()) // parse JSON from request
      .then((resultData) => {
        if (resultData.res) {
          let result = JSON.parse(resultData.res);
          if (result) {
            //parse the result and create a list of communities for communityDeals
            let cd = [];
            result.map((r) => {
              cd.push(r.scode1);
            });
            setCommunityDeals(cd);
            setDeals(result); //set for use
          }
        }
      })
      .catch((error) => console.log("Error getting if deals exist:", error));
  };
  const getPriceRange = async () => {
    await fetch("https://redisut.mcklab.com/index.php?action=getPriceRangeAll")
      .then((response) => response.json()) // parse JSON from request
      .then((resultData) => {
        if (resultData.res) {
          //console.log('resultData.res',resultData.res);
          let result = JSON.parse(resultData.res);
          result = trimKeys(result);
          //console.log('price range',result);
          setPriceRange(result); //set for use
        } else {
          console.log("resultData", JSON.stringify(resultData));
        }
      })
      .catch((error) => console.log("Error:", error));
  };
  const getProformaRange = async () => {
    await fetch(
      "https://redisut.mcklab.com/index.php?action=getProformaRangeAll",
    )
      .then((response) => response.json()) // parse JSON from request
      .then((resultData) => {
        if (resultData.res) {
          //console.log('resultData.res',resultData.res);
          let result = JSON.parse(resultData.res);
          result = trimKeys(result);
          //console.log('price range',result);
          setProformaRange(result); //set for use
        } else {
          console.log("resultData", JSON.stringify(resultData));
        }
      })
      .catch((error) => console.log("Error:", error));
  };
  const getAvShortcut = async () => {
    await fetch("https://redisut.mcklab.com/index.php?action=getCommunitiesAv")
      .then((response) => response.json()) // parse JSON from request
      .then((resultData) => {
        if (resultData.res) {
          let result = JSON.parse(resultData.res);
          //console.log(result);
          setAvShortcut(result); //set for use
        } else {
          console.log("resultData", JSON.stringify(resultData));
        }
      })
      .catch((error) => console.log("Error:", error));
  };

  const restoreViewing = () => {
    let viewingCity = [city];
    if (city === "ann-arbor") {
      viewingCity.push("ypsilanti");
    }
    if (city === "ypsilanti") {
      viewingCity.push("ann-arbor");
    }
    if (city === "orlando") {
      viewingCity.push("winter-park");
    }
    if (city === "all") {
      viewingCity = [
        "ypsilanti",
        "ann-arbor",
        "orlando",
        "winter-park",
      ];
    }
    const newViewing = data.allContentfulCommunity.edges
      .filter((m) => viewingCity.includes(m.node.citySlug))
      .map((m) => m.node);
    const sortedNewViewing = sortViewingByAvailabilityUtility(newViewing);
    //console.log("after", sortedNewViewing);
    setViewing(sortedNewViewing);
    if (originalViewing.length == 0) {
      // do this once
      setOriginalViewing(newViewing);
    }
  };

  const isViewed = (mapProps, map) => {
    // Does this need to work with filters?
    restoreViewing();
    let new_viewing = [];
    data.allContentfulCommunity.edges.map((m) => {
      let ll = { lat: m.node.exactLocation.lat, lng: m.node.exactLocation.lon };
      let latlong = new mapProps.google.maps.LatLng(ll);
      let inView = map.getBounds().contains(latlong);
      if (inView) {
        new_viewing.push(m.node);
      }
    });
    setViewing(new_viewing);
  };

  const filterBeds = (e) => {
    const selectedBeds = e.target.value ? Number(e.target.value) : "";
    const new_filter = { ...filter, bed: selectedBeds };
    setFilter(new_filter);
  };

  const filterBaths = (e) => {
    const selectedBaths = e.target.value ? Number(e.target.value) : "";
    const new_filter = { ...filter, bath: selectedBaths };
    setFilter(new_filter);
  };

  const filterPrice = (e) => {
    const selectedPrice = e.target.value ? Number(e.target.value) : "";
    const new_filter = { ...filter, rent: selectedPrice };
    setFilter(new_filter);
  };

  const filterAv = (e) => {
    const avToDisplay = e.target.value ? e.target.value : "";
    const new_filter = { ...filter, av: avToDisplay };
    setFilter(new_filter);
  };

  const filterAvAction = (res) => {
    const avToDisplay = filter.av;
    if (avToDisplay == "now") {
      res = res.filter((m) => {
        const communityAV = avShortcut[getYardiPropId(m.rmpropid)];
        return (
          communityAV.available && communityAV.availability_status == "now"
        );
      });
    }
    if (avToDisplay == "soon") {
      res = res.filter((m) => {
        const communityAV = avShortcut[getYardiPropId(m.rmpropid)];
        return communityAV.available;
      });
    }
    return res;
  };

  const filterBedsAction = (res) => {
    return filter.bed > 0
      ? res.filter((m) => Number(m.maxBeds) >= filter.bed)
      : res;
  };

  const filterBathsAction = (res) => {
    return filter.bath > 0
      ? res.filter((m) => {
          // Attempt to parse m.maxBaths as a number, if not available or NaN, use m.maxBathsDec
          const baths = Number(m.maxBaths) || parseFloat(m.maxBathsDec);
          return baths >= filter.bath;
        })
      : res;
  };

  const filterPriceAction = (res) => {
    const selectedPrice = Number(filter.rent);
    if (selectedPrice > 0) {
      let new_viewing = res.filter((m) => {
        const priceRangeData = priceRange[getYardiPropId(m.rmpropid)];
        const lowRent = parseFloat(priceRangeData?.low_rent) || 0;
        //const highRent = parseFloat(priceRangeData?.high_rent) || 0;
        //return selectedPrice >= lowRent && selectedPrice <= highRent;
        return selectedPrice >= lowRent;
      });
      res = new_viewing;
    }
    return res;
  };

  useEffect(() => {
    manageFilters();
  }, [filter]);

  const manageFilters = () => {
    // Allow all the filters to work together
    let new_viewing = [...originalViewing]; // we call an original clone
    if (filter.av && filter.av !== "" && filter.av != null) {
      new_viewing = filterAvAction(new_viewing);
    }
    if (filter.bed && filter.bed !== "" && filter.bed != null) {
      new_viewing = filterBedsAction(new_viewing);
    }
    if (filter.bath && filter.bath !== "" && filter.bath != null) {
      new_viewing = filterBathsAction(new_viewing);
    }
    if (filter.rent && filter.rent !== "" && filter.rent != null) {
      new_viewing = filterPriceAction(new_viewing);
    }
    setViewing(new_viewing);
  };

  const scrollPage = () => {
    let top = viewing.length;
    let vp = page[0] + 1;
    let vp1 = page[1] + 1;
    let vp2 = page[2] + 1;
    if (vp2 > top) {
      vp2 = vp1;
      vp1 = vp;
      vp = 0; //start over
    }
    setPage([vp, vp1, vp2]);
  };

  const sortViewingByAvailabilityUtility = (viewingArray) => {
    //console.log("city", city);
    //console.log("percentAvail", percentAvail);
    //console.log("before sorting", viewingArray);
    if (percentAvail) {
      // Convert percentAvail values to numbers and handle special cases
      const availNumbers = Object.fromEntries(
        Object.entries(percentAvail).map(([id, value]) => [
          id,
          parseFloat(value) || 0,
        ]),
      );
      //console.log("availNumbers", availNumbers);
      // Sort the viewing array based on availability
      let sortedViewing = [...viewingArray].sort((a, b) => {
        const availA = availNumbers[getYardiPropId(a.rmpropid)] || 0;
        const availB = availNumbers[getYardiPropId(b.rmpropid)] || 0;
        //return availB - availA; // Original was ascending, keeping it
        return availA - availB;
      });

      //console.log("sortedViewing", sortedViewing);

      // Apply custom sort override for Orlando
      if (city == "orlando") {
        const orlandoCustomOrder = [
          401500,400480,402050,400890
        ];

        // Move custom ordered items to the front
        orlandoCustomOrder.reverse().forEach((propId) => {
          const index = sortedViewing.findIndex(
            //(community) => getYardiPropId(community.rmpropid) == propId,
            (community) => community.rmpropid == propId,
          );
          if (index > -1) {
            const [item] = sortedViewing.splice(index, 1);
            sortedViewing.unshift(item);
          }
        });
        //console.log("orlando sortedViewing", sortedViewing);
      }

      // Apply custom sort override for Michigan (Ann Arbor/Ypsilanti)
      if (city == "ann-arbor") {
        const michiganCustomOrder = [
          401510, 400140, 400050, 401300
        ]; // Meadowbrook, Medical Center Court, Park Place, Traver Courts

        // Move custom ordered items to the front
        michiganCustomOrder.reverse().forEach((propId) => {
          const index = sortedViewing.findIndex(
            (community) => community.rmpropid == propId,
          );
          if (index > -1) {
            const [item] = sortedViewing.splice(index, 1);
            sortedViewing.unshift(item);
          }
        });
        //console.log("michigan sortedViewing", sortedViewing);
      }

      // Apply custom sort override for Michigan (Ann Arbor/Ypsilanti)
      if (city == "ypsilanti") {
        const ypsilantiCustomOrder = [
          400260, 400930, 400090, 400170
        ]; // Schooner, Evergreen, Villas, Aspen

        // Move custom ordered items to the front
        ypsilantiCustomOrder.reverse().forEach((propId) => {
          const index = sortedViewing.findIndex(
            (community) => community.rmpropid == propId,
          );
          if (index > -1) {
            const [item] = sortedViewing.splice(index, 1);
            sortedViewing.unshift(item);
          }
        });
        //console.log("michigan sortedViewing", sortedViewing);
      }


      return sortedViewing; // Return the potentially re-sorted array
    } else {
      // If percentAvail is not available, just return the original array 
      return viewingArray;
    }
  };

  // useEffect(() => {
  //    sortViewingByAvailability();
  //}, [percentAvail]); // Re-run this effect if percentAvail changes

  return (
    <section className={fontColorDark}>
      <div className=" container">
        <div className="columns is-multiline is-desktop">
          {isMobile ? (
            <>
              <div className="column">
                <div id="gmap_wrap">
                  {!loadingCords && (
                    <GoogleApiWrapper
                      lat={cords.lat}
                      long={cords.lon}
                      nodes={viewing}
                      area={state}
                      citySlug={city}
                      isViewed={isViewed}
                      hoveringOver={hoveringOver}
                      //minPrices={minPrices}
                      priceRange={priceRange}
                      proformaRange={proformaRange}
                    />
                  )}
                </div>
              </div>
              <SearchNotMap
                filterBeds={filterBeds}
                filterBaths={filterBaths}
                filterPrice={filterPrice}
                filterAv={filterAv}
                viewing={viewing}
                communityDeals={communityDeals}
                priceRange={priceRange}
                proformaRange={proformaRange}
                setHoveringOver={setHoveringOver}
              />
            </>
          ) : (
            <>
              <SearchNotMap
                filterBeds={filterBeds}
                filterBaths={filterBaths}
                filterPrice={filterPrice}
                filterAv={filterAv}
                viewing={viewing}
                communityDeals={communityDeals}
                priceRange={priceRange}
                proformaRange={proformaRange}
                setHoveringOver={setHoveringOver}
              />

              <div className="column">
                <div id="gmap_wrap">
                  {!loadingCords && (
                    <GoogleApiWrapper
                      lat={cords.lat}
                      long={cords.lon}
                      zoom={zoom}
                      nodes={viewing}
                      area={state}
                      citySlug={city}
                      isViewed={isViewed}
                      hoveringOver={hoveringOver}
                      //minPrices={minPrices}
                      proformaRange={proformaRange}
                      priceRange={priceRange}
                    />
                  )}
                </div>
              </div>
            </>
          )}
        </div>
      </div>
      <br />
      <br />
    </section>
  );
};

export default Search;
